import { createApp } from "vue";
import App from "./App.vue";
import "./style.css";
import router from "./router";
import store from "./store";

const app = createApp(App);

// Use router and store on the same app instance
app.use(store);
app.use(router);

store.dispatch("bootstrap");

app.mount("#app");
